import type { ComponentStyleConfig } from '@chakra-ui/theme';
import { Colors, Radii, Space } from '../../types';

export const Progress: ComponentStyleConfig = {
  baseStyle: props => ({
    filledTrack: {
      bgColor: `${props.colorScheme}.500`,
      rounded: 0,
      _dark: {
        bgColor: `${props.colorScheme}.600`,
      },
    },
    track: {
      bgColor: Colors.SURFACE_NEUTRAL_MUTED,
      borderRadius: Radii.XS,
      outline: '1px solid',
      outlineColor: Colors.BORDER_SUBDUED,
      outlineOffset: '-1px',
    },
  }),

  sizes: {
    xs: {
      track: { h: Space.SPACE_1 },
    },
    sm: {
      track: { h: Space.SPACE_1_5 },
    },
    md: {
      track: { h: Space.SPACE_2 },
    },
    lg: {
      track: { h: Space.SPACE_4 },
    },
  },
};
